import React, { useState } from 'react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Select } from './ui/select';


const combustionTypes = [
  { value: 'stationary', label: 'Stationary Combustion (e.g., from boilers, furnaces)' },
  { value: 'mobile', label: 'Mobile Combustion (e.g., from vehicles)' },
];

const fuelTypes = [
    { value: 'natural_gas', label: 'Natural Gas' },
    { value: 'heating_oil', label: 'Heating Oil' },
    { value: 'lpg', label: 'LPG' },
    { value: 'coal', label: 'Coal' },
    { value: 'propane', label: 'Propane' },
];

const vehicleTypes = [
    { value: 'petrol', label: 'Petrol Car' },
    { value: 'diesel', label: 'Diesel Car' },
    { value: 'hybrid', label: 'Hybrid Car' },
    { value: 'electric', label: 'Electric Car' },
];

export interface Scope1FormProps {
  onSubmit: (formData: any) => void;
  isSubmitting: boolean;
  // ...other props if needed
}

// Removed duplicate Scope1Form definition to resolve redeclaration error.


export function Scope1Form({ onSubmit, isSubmitting }: Scope1FormProps) {
  const [combustionType, setCombustionType] = useState('stationary');
  const [formData, setFormData] = useState({
    fuel_type: 'natural_gas',
    fuel_consumption: '',
    vehicle_type: 'petrol',
    distance_km: '',
  });

  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const submissionData = {
      combustion_type: combustionType,
      ...(combustionType === 'stationary' && {
        fuel_type: formData.fuel_type,
        fuel_consumption: parseFloat(formData.fuel_consumption),
      }),
      ...(combustionType === 'mobile' && {
        vehicle_type: formData.vehicle_type,
        distance_km: parseFloat(formData.distance_km),
      }),
    };
    onSubmit(submissionData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
        <Select
            value={combustionType}
            options={combustionTypes}
            onChange={(e: any) => setCombustionType(e.target ? e.target.value : e)}
        />

      {combustionType === 'stationary' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Select
                value={formData.fuel_type}
                options={fuelTypes}
                onChange={(e) => handleChange('fuel_type', e.target.value)}
            />
          <Input
            placeholder="Fuel Consumed"
            type="number"
            step="0.01"
            value={formData.fuel_consumption}
            onChange={(e) => handleChange('fuel_consumption', e.target.value)}
            required
          />
        </div>
      )}

      {combustionType === 'mobile' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            value={formData.vehicle_type}
            options={vehicleTypes}
            onChange={(e) => handleChange('vehicle_type', e.target.value)}
          />
          <Input
            placeholder="Distance (km)"
            type="number"
            step="0.01"
            value={formData.distance_km}
            onChange={(e) => handleChange('distance_km', e.target.value)}
            required
          />
        </div>
      )}

      <div className="flex justify-end">
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting…' : 'Next'}
        </Button>
      </div>
    </form>
  );
}
